"use client";

// app/ningenie/components/ConvexClientProvider.tsx
// baby: Client-side Convex provider for real-time updates
// baby: Wraps the app with ConvexProvider for useQuery/useMutation hooks

import { ConvexProvider, ConvexReactClient } from "convex/react";
import { ReactNode } from "react";

// baby: Get Convex URL from environment (must be NEXT_PUBLIC_ for client access)
const convexUrl = process.env.NEXT_PUBLIC_CONVEX_URL;

if (!convexUrl) {
  throw new Error("NEXT_PUBLIC_CONVEX_URL environment variable is not set");
}

// baby: Create singleton Convex client for client-side React components
const convex = new ConvexReactClient(convexUrl);

interface ConvexClientProviderProps {
  children: ReactNode;
}

// baby: Provider component to wrap app with Convex context
export const ConvexClientProvider = ({ children }: ConvexClientProviderProps) => {
  return (
    <ConvexProvider client={convex}>
      {children}
    </ConvexProvider>
  );
};
